module.exports = __webpack_public_path__ + "img/less-fruit-icon-white.f76a9fe0.svg";